var vars = require('./core');

module.exports = vars.createClass('Scatter', ['getPointsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/scatter.js
 ** module id = 974
 ** module chunks = 2
 **/